export interface Faq {
  q: string
  a: string[]
}

export const faqs: Faq[] = [
  {
    q: 'How do I receive Olympic Weightlifting Coach Ready after purchasing?',
    a: [
      'You receive digital access after your purchase is completed. The complete package is delivered as PDF resources that can be opened on compatible devices.',
    ],
  },
  {
    q: 'Is this an app?',
    a: [
      'No.',
      'Olympic Weightlifting Coach Ready is a PDF-based digital coaching system.',
      'Any Class Finder-style visuals shown on the sales page are promotional representations of how the session library is organized and do not represent standalone software.',
    ],
  },
  {
    q: 'Does the package contain videos?',
    a: [
      'No.',
      'The complete system is delivered as PDF resources.',
      'The material emphasizes visual learning inside the PDFs through technique sequences, bar-path diagrams, athlete-position references, step-by-step progressions, Correct vs Incorrect comparisons, drill illustrations, technical checklists and quick-reference cards.',
    ],
  },
  {
    q: 'Is the material in English?',
    a: ['Yes.', 'The complete Olympic Weightlifting Coach Ready system is provided in English.'],
  },
  {
    q: 'Can I edit the files?',
    a: [
      'No.',
      'The resources are delivered as finished PDF files and are not provided as editable documents.',
    ],
  },
  {
    q: 'Is this only for beginner coaches?',
    a: [
      'No.',
      'The system can support newer coaches who need more structure as well as experienced coaches who want visual technical references, ready-to-use sessions, correction tools and additional programming resources.',
    ],
  },
  {
    q: 'Is this only for beginner athletes?',
    a: [
      'No.',
      'The system progresses from fundamental movement and technical foundations through more advanced training and athlete-development applications.',
    ],
  },
  {
    q: 'Does this replace formal Olympic Weightlifting coaching education or certification?',
    a: [
      'No.',
      'Olympic Weightlifting Coach Ready is a coaching resource and planning system.',
      'It does not replace required certifications, federation-specific education or professional qualifications.',
    ],
  },
  {
    q: 'Can I use the 150 sessions exactly as written?',
    a: [
      'The sessions are designed to provide ready-to-use coaching structures.',
      'Coaches should still adapt loading, intensity, volume and exercise selection to the individual athlete, their experience, technical level and training conditions.',
    ],
  },
]
